import { Typography } from '@material-ui/core'

import { useStyles } from './styles'

interface LabelProps {
  title: string
}

export const Label = ({ title }: LabelProps) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <Typography>{title}</Typography>
    </div>
  )
}
